export enum ActionType {
	Add = "Add",
	Edit = "Edit",
	Delete = "Delete",
	View = "View",
	UndoDelete = "Undo Delete",
	Increase = "Increase",
	Decrease = "Decrease",
	Cancel = "Cancel",
	Join = "Join",
}
